export class PayzenModel {
    id_pais?: string;
    documento?: string;
    tipo_documento?: string;
    vads_shop_name?: string;
    vads_shop_url?: string;
    vads_amount?: string;
    vads_order_id?: string;
    vads_url_return?: string;
    vads_cust_id?: string;
    vads_cust_email?: string;
    vads_order_info?: string;
    factura?: boolean;
  
    constructor() {
      this.id_pais = "1";
      this.vads_shop_name = "Covinoc";
      this.vads_shop_url = "https://covinoc.com/";
      this.vads_url_return = "https://covifactura.com/";
    }
  }